module.exports = __webpack_public_path__ + "static/media/m2.e915333d.svg";